import { Injectable, signal, WritableSignal } from "@angular/core";




@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private show: WritableSignal<boolean> = signal<boolean>(false);

  readonly showModal = this.show.asReadonly();

  open() {
    this.show.set(true)
  }
  close() {
    this.show.set(false)
  }
}
